import React, {
  createContext,
  Suspense,
  lazy,
  useCallback,
  useContext,
  useMemo,
  useRef,
  useState,
} from 'react';

const ProductQuickView = lazy(() => import('./ProductQuickView'));

const ProductQuickViewContext = createContext({
  openQuickView: () => false,
});

export const useProductQuickView = () => useContext(ProductQuickViewContext);

export const ProductQuickViewProvider = ({ children }) => {
  const [request, setRequest] = useState(null);
  const triggerRef = useRef(null);

  const openQuickView = useCallback((nextRequest, triggerElement) => {
    if (
      !nextRequest?.merchantId ||
      !nextRequest?.productId ||
      !nextRequest?.productPath
    ) {
      return false;
    }

    triggerRef.current =
      typeof HTMLElement !== 'undefined' &&
      triggerElement instanceof HTMLElement
        ? triggerElement
        : null;
    setRequest({
      ...nextRequest,
      requestId: `${nextRequest.merchantId}-${nextRequest.productId}-${Date.now()}`,
    });
    return true;
  }, []);

  const closeQuickView = useCallback(() => {
    setRequest(null);
    window.setTimeout(() => {
      if (triggerRef.current?.isConnected) {
        triggerRef.current.focus({ preventScroll: true });
      }
      triggerRef.current = null;
    }, 0);
  }, []);

  const contextValue = useMemo(() => ({ openQuickView }), [openQuickView]);

  return (
    <ProductQuickViewContext.Provider value={contextValue}>
      {children}
      {request ? (
        <Suspense fallback={null}>
          <ProductQuickView request={request} onClose={closeQuickView} />
        </Suspense>
      ) : null}
    </ProductQuickViewContext.Provider>
  );
};
